import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { commonAiApi } from '../services/ai';
import { RootState } from '../../../store';

interface State {
    imageUrl: string;
    isLoading?: boolean;
    isSuccess?: boolean;
    error?: string;
    prompt?: string;
}

const initialState: State = {
    imageUrl: '',
    isLoading: false,
    isSuccess: false,
    error: undefined,
    prompt: '',
};

export const generateImage = createAsyncThunk(
    'aiImage/generateImage',
    async (prompt: string, thunkAPI) => {
        try {
            const result = await thunkAPI
                .dispatch(
                    commonAiApi.endpoints.createAiImage.initiate({ prompt })
                )
                .unwrap();
            return result.url;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.message);
        }
    }
);

export const aiImageSlice = createSlice({
    name: 'aiImage',
    initialState,
    reducers: {
        setPrompt(state, action: { payload: string }) {
            state.prompt = action.payload;
            generateImage(action.payload);
        },
        resetImageState(state) {
            state.imageUrl = '';
            state.isLoading = false;
            state.isSuccess = false;
            state.error = undefined;
        },
    },
    extraReducers: builder => {
        builder.addCase(generateImage.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.imageUrl = payload;
        });
        builder.addCase(generateImage.pending, (state, { payload }) => {
            state.isLoading = true;
            state.isSuccess = false;
        });
    },
});

export const selectAIImageState = (state: RootState) => state.aiImageSelector;

export const { setPrompt } = aiImageSlice.actions;

export const aiImageReducer = aiImageSlice.reducer;
